export const environment = {
    production: true,
    apiUrl: 'https://o.orderwithflavor.com/',
    wsUrl: 'https://o.orderwithflavor.com',
    imgProcess: 'https://o.orderwithflavor.com/cdn/',
    catalogApiUrl: 'https://kyoo-catalog.s3.amazonaws.com/catalog/',
    tabUrl: 'https://o.orderwithflavor.com/',
    applicationId: 'sq0idp-UosDn7-gj7kyiYf6ZGnO8A',
    applicationIdCA: 'sq0idp-cybAWtzfpBEH0sJEYCx4gA',
    applicationIdGB: 'sq0idp-MFx5sXlo31vqb5KovJzJbQ',
    applicationIdAU: 'sq0idp-SPIH00H6rs-M3wzjvS2z6A',
    applicationIdJP: 'sq0idp-V1_Uo6yPF0aLHUEnHPzPZw',
    isKiosk: false,
    isKitchen: false,
    isLine: false,
    isStoneCreek:true,
    appName:'Order with Flavor'
  };
